import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

const SaveLoadControlBar = ({ onOpenManager }) => {
    const { t } = useTranslation();
    const { isAuthenticated, user } = useAuth();

    // GUEST TEASER VIEW
    if (!isAuthenticated) {
        return (
            <div className="w-full bg-gray-900 bg-opacity-95 backdrop-blur-md text-gray-300 px-6 py-4 flex flex-col md:flex-row justify-between items-center shadow-lg mb-6 rounded-xl border border-gray-700">
                <div className="flex items-center gap-4">
                    <div className="bg-gray-800 rounded-full p-2 shrink-0 border border-gray-600">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                    </div>
                    <div className="flex flex-col">
                        <span className="text-lg md:text-xl font-black text-white uppercase tracking-wider leading-tight">
                            {t('SaveLoadControlBar.guest_impact_header')}
                        </span>
                        <span className="text-sm font-medium text-gray-400">
                            {t('SaveLoadControlBar.guest_teaser')}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    // AUTHENTICATED VIEW
    return (
        <div className="w-full bg-indigo-900 bg-opacity-90 backdrop-blur-sm text-white px-6 py-2 flex justify-between items-center shadow-md mb-6 rounded-xl border border-indigo-700/50">
            <div className="flex items-center gap-3">
                <div className="bg-indigo-700 rounded-full p-1.5">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                    </svg>
                </div>
                <div>
                    <span className="text-xs text-indigo-300 font-bold uppercase tracking-wider block">{t('SaveLoadControlBar.status_sync_active')}</span>
                    <span className="text-sm font-medium">{t('SaveLoadControlBar.status_logged_in', { name: user?.name || t('SaveLoadControlBar.default_user') })}</span>
                </div>
            </div>

            <button
                onClick={onOpenManager}
                className="bg-white/10 hover:bg-white/20 text-white px-4 py-1.5 rounded-lg text-sm font-semibold transition-colors flex items-center gap-2 border border-white/10"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                </svg>
                {t('SaveLoadControlBar.button_manage')}
            </button>
        </div>
    );
};

export default SaveLoadControlBar;
// Revisado: 2025-12-18 [I18n Scan]
